import React, { useCallback, useEffect, useState } from "react";
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import s from './CustomerDollar.module.css';
import { useNavigate } from "react-router-dom";
import {RedButton, GreenButton, BlueButton} from './MyButton';
import {modifiedDate} from '../middleware/dateControl';
import { getGeneralStorage, setGeneralStorage} from '../middleware/dataStorage';

import MyComponentLoading from '../components/Utilities/MyComponentLoading';

export default function CustomerDollar(prop) {	
	const navigate = useNavigate();
	
	let userId = prop.userId;
	const [fetchCompleted, setFetchCompleted] = useState(true);
	const [toggleDetail, setToggleDetail] = useState(getGeneralStorage('CustomerDollarToggleDetail') ?? 0);

	const [dollar, setDollar] = useState(null);
	const [addDollar, setAddDollar] = useState(0);
	const [dollarTransactionLog, setDollarTransactionLog] = useState([]);
	
	const fetchData = async () => {
		let res = await getData('customerApi/getDollarByUserId?userId=' + userId, navigate)
		setDollar(res.data.dollar);
		
		res = await getData('customerApi/getDollarTransactionLogByUserId?userId=' + userId, navigate)
		setDollarTransactionLog(res.data);
		
		setFetchCompleted(true);
	}
	
	const sendDollarAdd = async() => {		
		if (addDollar>0) {
			
			let obj = {
				userId,
				'dollar': addDollar,
			}
			
			let res = await postData("customerApi/addDollar", obj, navigate); 
			setDollar(res.data);
			
			res = await getData('customerApi/getDollarTransactionLogByUserId?userId=' + userId, navigate)
			setDollarTransactionLog(res.data);
		}
		setAddDollar(null);
	}
	
	useEffect(() => {
		fetchData();
	}, []);
	
	if (!fetchCompleted) {
		return (<MyComponentLoading />)
	}
	
	return (<div className={s.mainHolder}>
		<div className={s.rowHolder}>
			Customer dollar: {dollar}
		</div>
		
		<div style={{display:"flex", margin:"5px 0", alignItems:"center", gap:"10px", height:"50px", borderBottom:(toggleDetail == 1) ? "": "4px solid #95abd6"}}>
			<div><input className={s.toggleBox} type="checkbox" name="" id="" checked={toggleDetail == 1}  onChange={ (e)=> {
				setToggleDetail((e.target.checked) ? 1 : 0);
				console.log(e.target.checked);
				setGeneralStorage('CustomerDollarToggleDetail', (e.target.checked) ? 1 : 0);
			}
			}/>
			</div>
			
			
				{
					(toggleDetail == 0) && (<div style={{display:"flex", alignItems:"center", gap:"2px", borderTopRightRadius:"10px", borderTopLeftRadius:"10px", 
					background:"#95abd6", padding:"0 10px 5px 10px", margin:"0 0 0 auto"}}>
						<div style={{fontWeight:"600"}}>Add Dollar: </div>
						<input className={s.simpleInput} type="text" value={addDollar} onChange={
							(e) => {
								let input = e.target.value;
								if (input === '' || /^[0-9]+$/.test(input)) {
									setAddDollar(input); // Update state only if it's valid
								}
							}
						}/>
						
						<div>
						<GreenButton isEnabled={(addDollar>0)} clickedAction={sendDollarAdd} bText={"send"} />
						</div>
					</div>)
				}
		</div>
		
		
		
		
				<div style={{display:"flex", flexDirection:"column", gap:"2px"}} className={(toggleDetail == 1) ? s.toggleTargetShow : s.toggleTargetHide}>
					{
						dollarTransactionLog.map((d, indexD)=>(<div key={indexD} 
							style={{display:"flex", borderTopLeftRadius:"4px", borderBottomLeftRadius:"4px", gap:"5px", alignItems:"center", 
							background:"#fdfef8",
							border:(d.isAdd == 0) ? "1px solid #e34c42": "1px solid #42a758"}}>
							{
								(d.isAdd == 1) && (<div className={s.netIcon} style={{background:"#42a758", color:"#e7f9dc"}}>
									<div>+{d.dollar}</div>
								</div>)
							}
							{
								(d.isAdd == 0) && (<div className={s.netIcon}  style={{background:"#e34c42", color:"#fcfbed"}}>
									<div>-{d.dollar}</div>
								</div>)
							}
							<div></div>
							<div>{d.msg}</div>
							<div style={{margin:"0 5px 0 auto"}}>{modifiedDate(d.createTs)}</div>
						</div>))
					}
				</div>
	</div>);
	
}

